<ng-container *transloco="let t">
<ng-template #reviewApplication>
  <div id="submitApplication">
    @if (isSubmitted && isEditEnabled) {
      <div class="alert alert-warning d-flex align-items-center p-5 mb-10">
        <span class="svg-icon svg-icon-2hx svg-icon-warning me-4">
          <duotone-warning-circle-svg-icon></duotone-warning-circle-svg-icon>
        </span>
        <div class="d-flex flex-column">
          <h5 class="mb-1">{{ t('wizard.review.willNotSubmitTitle') }}</h5>
          <span>{{ t('wizard.review.adminEditingWarning') }}</span>
        </div>
      </div>
    }
  </div>

  @if (inEditMode) {
    <div class="d-flex mb-5">
      <div class="col-sm-3 col-form-label fw-bold fs-6 editor-label">{{ t('wizard.review.allowEditingSubjectProperty') }}:</div>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
        <input class="form-check-input h-20px w-30px" type="checkbox" id="allowEditingOfSubjectProperty"
          name="allowEditingOfSubjectProperty" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="step.allowEditingOfSubjectProperty" />
        <label class="form-check-label" for="allowEditingOfSubjectProperty">
          {{step.allowEditingOfSubjectProperty ? t('common.yes') : t('common.no')}}
        </label>
      </div>
    </div>

    <div class="d-flex mb-5">
      <div class="col-sm-3 col-form-label fw-bold fs-6 editor-label">{{ t('wizard.review.showSubjectPropertyDetails') }}:</div>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
        <input class="form-check-input h-20px w-30px" type="checkbox" id="showSubjectPropertyDetails"
          name="showSubjectPropertyDetails" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="step.showSubjectPropertyDetails" />
        <label class="form-check-label" for="showSubjectPropertyDetails">
          {{step.showSubjectPropertyDetails ? t('common.yes') : t('common.no')}}
        </label>
      </div>
    </div>

    <div class="d-flex mb-5">
      <div class="col-sm-3 col-form-label fw-bold fs-6 editor-label">{{ t('wizard.review.showSubmitAndGeneratePdf') }}:</div>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
        <input class="form-check-input h-20px w-30px" type="checkbox" id="showSubmitAndGeneratePdfButton"
          name="showSubmitAndGeneratePdfButton" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="step.showSubmitAndGeneratePdfButton" />
        <label class="form-check-label" for="showSubmitAndGeneratePdfButton">
          {{step.showSubmitAndGeneratePdfButton ? t('common.yes') : t('common.no')}}
        </label>
      </div>
    </div>
  }


  <div id="reviewApplication">
    <borrower-review-application [mortgage]="mortgageApplication" [borrower]="mainBorrower" (borrowerChanged)="onBorrowerChanged($event)" [subjectProperty]="subjectProperty" [purchasePrice]="purchasePrice"></borrower-review-application>
    @if (!inCoApplyFlow) {
      @for (borrower of coBorrowers; track borrower.borrowerId) {
        <div>
          @if (borrowerSetting(borrower)) {
            <div>
              <borrower-review-application [mortgage]="mortgageApplication" [borrower]="borrower" (borrowerChanged)="onBorrowerChanged($event)" [subjectProperty]="subjectProperty" [purchasePrice]="purchasePrice"></borrower-review-application>
            </div>
          }
        </div>
      }
    }
    <div class="rounded border p-5 mb-6">
      @if (!inCoApplyFlow) {
        <div class="w-100 d-flex align-items-center justify-content-end">
          <a href="javascript:void(0);" class="text-primary fw-bold fs-7 mt-n2"
            (click)="onLoanSummaryEditClicked()">
             {{ t('common.edit') }}
          </a>
        </div>
      }
      <loan-summary
        [inEditMode]="inEditMode"
        [fieldsToConfig]="step.fieldConfig"
        [step]="this.step"
        [subjectProperty]="subjectProperty"
        [mortgageTerm]="mortgageTerm"
        [transactionDetail]="transactionDetail"
        [ltvValueBasis]="ltvValueBasis"
        (loanDetailsClicked)="onLoanDetailsClicked()"
        class="flex-fill">
      </loan-summary>
    </div>

    @if (step.showSubjectPropertyDetails) {
      <div class="rounded border p-5 mb-6">
        @if (!inCoApplyFlow && step.allowEditingOfSubjectProperty && !disableEditSubjectPropertyAddress) {
          <div class="w-100 d-flex align-items-center justify-content-end">
            <a href="javascript:void(0);" class="text-primary fw-bold fs-7 mt-n2"
              (click)="onSubjectPropertySummaryEditClicked()">
               {{ t('common.edit') }}
            </a>
          </div>
        }
        <subject-property-summary
          [disableEdit]="disableEditSubjectPropertyAddress"
          (subjectPropertyDetailsClicked)="onSubjectPropertyDetailsClicked();"
          [subjectProperty]="subjectProperty"
          class="flex-fill">
        </subject-property-summary>
      </div>
    }
  </div>

</ng-template>

<wizard-step-template [stepMainTemplate]="reviewApplication" [step]="step" [stepComponent]="this" [customButtons]="customButtons">
</wizard-step-template>
</ng-container>
